
import { Component, Input, OnInit} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';
import { FullProfileAnimationModel } from '../../../Core/Dialogs/models/full-profile-animation.model';
import { FullProfileDialogAnimationsEnum } from '../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../Core/Dialogs/enums/overlay-animation.enum';
import { UpsellDialogType, UpsellInfoDialogComponent } from '../../../Common/Dialogs/components/UpsellInfoDialog/upsell-info-dialog.component';
import { CoreDialogService } from '../../../Core/Dialogs/services/dialog.service';
import { LandingPageFeatureItem } from 'app/LandingPage/models/feature-item.model';
import { ConfigService } from '../../../Core/Config/services/config.service';
import { NAVBAR_IDS } from '../LandingPage/product-features.const';

@Component({
    selector: 'agpr-product-features',
    templateUrl: './product-features.html',
    styleUrls: ['./product-features.scss'],
    standalone: false
})

export class ProductFeaturesComponent implements OnInit {
    @Input() header: string;
    @Input() subItems: LandingPageFeatureItem[] = [];
    @Input() featurePermission: boolean = true;
    @Input() upsellMessage: string;
    @Input() featureId: string;
    @Input() id: string;

    overlayContainer: Element;
    isWhiteLabeledBrand: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;
    readonly NAVBAR_IDS = NAVBAR_IDS;

    constructor(public coreDialogService: CoreDialogService, protected configService: ConfigService) { }

    ngOnInit(): void {
        this.overlayContainer = document.getElementById('main-content');
        this.isWhiteLabeledBrand = this.configService.isWhiteLabelBrand();
    }

    openUpsellInfoPanel(featureId: string): void {
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );
        let type: UpsellDialogType;
        switch (featureId) {
            case this.NAVBAR_IDS.MEDIA_INTELLIGENCE:
                type = UpsellDialogType.monitor;
                break;
            case this.NAVBAR_IDS.MEDIA_RELATIONS:
                type = UpsellDialogType.discover;
                break;
            case this.NAVBAR_IDS.SOCIAL:
                type = UpsellDialogType.social;
                break;
        }
        const io = {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: this.overlayContainer,
                type: type
            }
        };
        this.coreDialogService.open(UpsellInfoDialogComponent, io);
    }
}
